const head_US_Locale = {
    'head.aboutUs': 'About Us',
    'head.products': 'Products',
    'head.solution': 'Solutions',
    'head.newsUpdates': 'News & Updates',
    'head.zh_language': '中文',
    'head.en_language': 'ENG',
    'head.selectLanguage': 'Select Region/Language',
    'head.pair': 'Pair丨Medical Image Annotation Software',
    'head.cupid': 'CUPID丨Al For Fetal Ultrasound Scan',
    'head.autoPelvic': 'AutoPelvic丨AI For Pelvic Ultrasound Scan',
    'head.autoDDH': 'AutoDDH丨Al For Hip Joint Ultrasound Scan',
    'head.Breast': 'AutoBreast丨Al For Breast Ultrasound Scan',
    'head.AutoThyroid': 'AutoThyroid丨Al For Thyroid Ultrasound Scan',
    'head.AutoCardiac': 'AutoCardiac 丨Al For Cardiac Ultrasound Scan',
    'head.AutoFollicle': 'AutoFollicle丨Al For Follicle Ultrasound Scan',
    'head.ATLAS': 'ATLAS丨Intelligent Quality Control Platform',
    'head.fullStack': 'Full-Stack Intelligent Ultrasound Solutions',
    'head.NICE': 'NiCE: Ultrasound Imaging AI Deployment Platform'
}
export default head_US_Locale
